/* eslint-disable react-hooks/rules-of-hooks */
/// <reference types="react/experimental" />
import * as React from 'react';
import { useMemo } from 'react';
import { hasSnapshot, identitySelector, nullSource, } from 'retil-source';
var _a = React, createMutableSource = _a.unstable_createMutableSource, useMutableSource = _a.unstable_useMutableSource;
var MissingToken = Symbol();
var subscribe = function (_a, cb) {
    var subscribe = _a[1];
    return subscribe(cb);
};
var mutableSources;
export var useSourceModern = function (maybeSource, options) {
    if (options === void 0) { options = {}; }
    var hasDefaultValue = 'defaultValue' in options;
    var defaultValue = options.defaultValue, startTransition = options.startTransition;
    var _a = maybeSource || nullSource, core = _a[0], select = _a[1];
    if (!mutableSources) {
        mutableSources = new WeakMap([
            [nullSource[0], createMutableSource(nullSource[0], nullSource[0][0])],
        ]);
    }
    var getSnapshot = useMemo(function () {
        return hasDefaultValue
            ? function (core) {
                return hasSnapshot([core, select]) ? select(core) : MissingToken;
            }
            : select;
    }, [hasDefaultValue, select]);
    var subscribeWithTransition = useMemo(function () {
        return startTransition
            ? function (_a, callback) {
                var subscribe = _a[1];
                return subscribe(function () {
                    startTransition(callback);
                });
            }
            : subscribe;
    }, [startTransition]);
    var mutableSource = mutableSources.get(core);
    if (!mutableSource) {
        var getVersion = function () {
            return hasSnapshot([core, identitySelector]) ? core[0]() : MissingToken;
        };
        mutableSource = createMutableSource(core, getVersion);
        mutableSources.set(core, mutableSource);
    }
    var value = useMutableSource(mutableSource, getSnapshot, subscribeWithTransition);
    return value === MissingToken || maybeSource === null ? defaultValue : value;
};
